import {api} from "../../src/api";
import {trackException} from "../../src/errors";
import {Notifications} from "../../src/notifications";

document.addEventListener("DOMContentLoaded", () => {
    initCalendar();
});

const initCalendar = () => {
    const today = moment().startOf('day').format('YYYY-MM-DD');

    const calendarEl = document.getElementById('calendar');
    const calendar = new FullCalendar.Calendar(calendarEl, {

        headerToolbar: {
            start: 'prev next',
            center: 'title',
            end: 'dayGridMonth,listWeek'
        },
        titleFormat: {month: 'long'},

        timeZone: 'UTC',
        aspectRatio: window.innerWidth > 500 ? 2 : 0.75,

        nowIndicator: true,
        now: today + 'T00:00:00',

        views: {
            dayGridMonth: {buttonText: 'month'},
            listWeek: {buttonText: 'list'}
        },

        buttonIcons: true,

        initialView: window.innerWidth > 500 ? 'dayGridMonth' : 'listWeek',
        eventTimeFormat: {
            hour: '2-digit',
            minute: '2-digit',
            meridiem: false,
            hour12: false
        },

        fixedWeekCount: false,
        showNonCurrentDates: false,
        editable: false,
        navLinks: true,
        firstDay: 1,

        events: async function (info, successCallback, failureCallback) {

            try {
                const {data} = await api.get(`/api/sessions?startDate=${info.startStr}&endDate=${info.endStr}&includeAllInstances=true`);
                successCallback(
                    data.items.map(row => ({
                        id: row.id,
                        title: row.name,
                        start: row.startDateUtc,
                        end: row.endDateUtc,
                        url: row.url,
                        className: `session-${row.color}`,
                        timezone: 'UTC'
                    }))
                );
            } catch (ex) {
                trackException(ex);
                Notifications.showError({ message: "There was an error fetching the events." });
            }

        }
    });

    calendar.render();
}
